import { NOT_FINISHED_QUEUE_STATUSES } from '../constants/queue';
import { SHIPPING_NOT_SEND_STATUSES } from '../constants/shipping';
import {
	NOT_EDITABLE_ONLINE_PAYMENT_STATUS,
	NOT_EDITABLE_STATUSES,
} from '../constants/statuses';

export const checkIsOrderEditable = (order) => {
	if (NOT_FINISHED_QUEUE_STATUSES.includes(order?.status)) {
		return true;
	}

	if (order.status !== 'confirmed') {
		return false;
	}

	if (order?.payment?.length > 0) {
		const statuses = order?.payment?.map((p) => p.status);
		if (statuses?.includes(NOT_EDITABLE_ONLINE_PAYMENT_STATUS)) {
			return false;
		}
	}

	if (
		order?.shipping?.status &&
		!SHIPPING_NOT_SEND_STATUSES.includes(order?.shipping?.status)
	) {
		return false;
	}

	if (order?.payment?.length > 0) {
		const statuses = order?.payment?.map((p) => p.status);
		if (!statuses?.includes(NOT_EDITABLE_ONLINE_PAYMENT_STATUS)) {
			return true;
		}
	}

	if (!order?.shipping?.status) {
		return true;
	}

	return !NOT_EDITABLE_STATUSES.includes(order?.status);
};
